export default "__VITE_ASSET__BxJmD2cD__"